<template>
    <div>
        <div class="text-2xl text-grey-darkest mb-4">{{ member.name }}'s Settings</div>
        <div class="text-teal hover:text-teal-dark font-base text-sm mb-4 flex justify-between">
            <div @click="goBack" class="flex cursor-pointer">
                <span class="material-icons">chevron_left</span>
                <span>Back</span>
            </div>
            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                @click="saved" type="button">
                Save
            </button>
        </div>

        <div class="mb-6 w-1/5">
            <label class="text-sm text-grey-darkest">Reports to</label>
            <multiselect class="cursor-pointer" :options="users" v-model="form.reports_to" :show-labels="false"
                         track-by="id" label="name"></multiselect>
        </div>

        <div class="w-full">
            <div v-for="(sb_settings, index) in form.settings"
                 class="flex">
                <div class="mr-4 text-right w-1/6">{{ sb_settings.name }}:</div>
                <div class="mr-4">
                    <label class="text-grey-darkest mr-2">
                    <input type="radio" :name="'settings_' + sb_settings.name" :value="0" :checked="sb_settings.days_count === 0"
                           v-model="sb_settings.days_count">
                        No Alerts</label>
                </div>
                <div class="mr-4">
                    <input type="radio" :name="'settings_' + sb_settings.name" :value="1" :checked="sb_settings.days_count === 1"
                           v-model="sb_settings.days_count">
                    <label class="text-grey-darkest mr-2">1 Day</label>
                </div>
                <div class="mr-4">
                    <input  type="radio" :name="'settings_' + sb_settings.name" :value="2" :checked="sb_settings.days_count === 2"
                           v-model="sb_settings.days_count">
                    <label class="text-grey-darkest mr-2">2 Days</label>
                </div>
                <div class="mr-4">
                    <input type="radio" :name="'settings_' + sb_settings.name" :value="3" :checked="sb_settings.days_count === 3"
                           v-model="sb_settings.days_count">
                    <label class="text-grey-darkest mr-2">3 Days</label>
                </div>
                <div class="mr-4">
                    <input type="radio" :name="'settings_' + sb_settings.name" :value="4" :checked="sb_settings.days_count === 4"
                           v-model="sb_settings.days_count">
                    <label class="text-grey-darkest mr-2">4 Days</label>
                </div>
                <div>
                    <input type="radio" :name="'settings_' + sb_settings.name" :value="5" :checked="sb_settings.days_count === 5"
                           v-model="sb_settings.days_count">
                    <label class="text-grey-darkest mr-2">5 Days</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Form from "../../../utils/form";
    import Multiselect from 'vue-multiselect';

    export default {
        props: ['member', 'users', 'currentTeamId', 'actionTeamId'],
        components: {Multiselect},

        data() {
            return {
                selected: 1,
                form: new Form({
                    settings: this.member.sales_behavior_notification_settings,
                    reports_to: this.member.reports_to,
                }),
            }
        },

        methods: {
            goBack() {
                window.location = '/settings/teams/' + this.currentTeamId + '#/membership';
            },

            saved() {
                let self = this;
                self.form.put(route('api.settings.member.notification-settings.update', {member: self.member.id})).then(() => {
                    window.location = route('settings.member.notification-settings.edit-user-settings', {team: this.actionTeamId, member: self.member.id});
                });
            },
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
